import axios from 'axios';
import authHeader from '../auth/auth.header';

const instance = axios.create({
  baseURL: import.meta.env.VITE_APP_SITE,
  headers: {
    'Content-Type': 'application/json',
    ...authHeader()
  }
});
export default instance;

export const reportsApi = axios.create({
  baseURL: import.meta.env.VITE_APP_REPORTS_API,
  headers: {
    'Content-Type': 'application/json'
  }
});
